import { render } from "./MediaObjectList.vue?vue&type=template&id=8725b3bc"
import script from "./MediaObjectList.vue?vue&type=script&lang=js"
export * from "./MediaObjectList.vue?vue&type=script&lang=js"

import "./MediaObjectList.vue?vue&type=style&index=0&id=8725b3bc&lang=scss"

import exportComponent from "../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__